export default "__VITE_ASSET__Ch3pMsih__"